import PersonContextMenu from './PersonContextMenu';

export * from './PersonContextMenu';

export default PersonContextMenu;